import { Button, Card, Col, Flex, Grid } from "antd";
import { SpaceBetweenDiv } from "components/divs";
import { compact } from "lodash";
import React, { useCallback } from "react";
import { spacing } from "styles/spacing";

import { Splash } from "../../Splash";
import { Footer } from "./Footer";

export type PromptCardProps = {
  title: string;
  features: React.ReactNode[];
  disabled?: boolean;
  disabledText?: JSX.Element;
  onSecondary?: {
    text: string;
    shortText?: string;
    onClick: () => void;
  };
  onPrimary: {
    text: string;
    shortText?: string;
    onClick: () => void;
  };
};

const PromptCard = React.memo(
  ({
    title,
    features,
    disabled,
    disabledText,
    onSecondary,
    onPrimary,
  }: PromptCardProps) => {
    const { xxl, xl } = Grid.useBreakpoint();
    const handlePrimary = useCallback(() => {
      onPrimary.onClick();
    }, [onPrimary]);

    const handleSecondary = useCallback(() => {
      onSecondary?.onClick();
    }, [onSecondary]);

    return (
      <Card title={title} style={{ width: "50%", margin: "auto" }}>
        <Flex
          vertical
          gap={spacing.scale.sm}
          style={{ height: xxl ? "15em" : "20em", overflow: "hidden" }}
        >
          {features.map((feature) => (
            <div key={`${title}-${feature}`}>{feature}</div>
          ))}
        </Flex>

        <SpaceBetweenDiv style={{ marginTop: spacing.scale.sm }}>
          {onSecondary && (
            <Button style={{ width: "45%" }} onClick={handleSecondary}>
              {!xl && onSecondary.shortText
                ? onSecondary.shortText
                : onSecondary.text}
            </Button>
          )}
          <Button
            disabled={disabled}
            type="primary"
            style={{ width: "45%" }}
            onClick={handlePrimary}
          >
            {disabled
              ? xl
                ? disabledText
                : "Soon"
              : !xl && onPrimary.shortText
                ? onPrimary.shortText
                : onPrimary.text}
          </Button>
        </SpaceBetweenDiv>
      </Card>
    );
  }
);

PromptCard.displayName = "PromptCard";

const InstallPromptStep = React.memo(
  ({
    prompts,
  }: {
    // The UI can only display up to 3 prompts at a time.
    prompts: [PromptCardProps, PromptCardProps?, PromptCardProps?];
  }) => {
    return (
      <Splash overrideColumn>
        <Col xs={22} md={16} lg={14} xl={12}>
          <Card bordered={false}>
            <Flex
              gap={spacing.layout.grid.gap.xs}
              style={{ marginBottom: spacing.scale.sm }}
            >
              {compact(prompts).map((prompt, ix) => (
                <PromptCard key={`${ix}-${prompt.title}`} {...prompt} />
              ))}
            </Flex>

            <Footer />
          </Card>
        </Col>
      </Splash>
    );
  }
);

InstallPromptStep.displayName = "InstallPromptStep";

export { InstallPromptStep, PromptCard };
